module.exports = __webpack_public_path__ + "img/tik.41fc8df7.svg";